import type { Locale } from "../../shared/dto";
import { AdminImportHistory } from "./AdminImportsHistory";
// The area owns its stylesheet, so staff.css stays untouched by this wave.
// The import belongs HERE and not in the leaf modules: the visual harness
// (artifacts/sw3/preview.tsx) renders those leaves through plain tsx, which
// cannot load a stylesheet, and it inlines the file itself instead.
import "./admin-imports.css";

// Entry point of the Servis area "Klienti a importy" (wave 3). The client
// creation form keeps its own group in the console shell and uses
// useClientCreation + AdminClientCreatedCard from AdminImportsCreate; this
// panel owns the shared history of everything that arrived from outside.

export function AdminImports(props: {
  t: (key: string) => string;
  locale: Locale;
  csrfToken: string;
  hideTestTenants: boolean;
  onHideTestTenantsChange?: (hide: boolean) => void;
  onOpenClient?: (clientId: string) => void;
}) {
  return (
    <div className="admin-imports">
      <AdminImportHistory t={props.t} locale={props.locale} csrfToken={props.csrfToken}
        hideTestTenants={props.hideTestTenants}
        onHideTestTenantsChange={props.onHideTestTenantsChange}
        onOpenClient={props.onOpenClient} />
    </div>
  );
}

export { AdminImportHistory, AdminImportRows } from "./AdminImportsHistory";
export { AdminClientCreatedCard, useClientCreation } from "./AdminImportsCreate";
export {
  AdminImportsFeedback,
  filteredImportRows,
  importCounts,
  importConfigSourceKey,
  importFixKey,
  importReasonKeys,
  visibleImportRows
} from "./AdminImportsShared";
